import React from "react";
import {
     CheckCircleOutlined,
     CloseCircleFilled,
     CopyFilled,
     LoadingOutlined,
     RedoOutlined,
     StopOutlined,
     UserOutlined,
     WarningOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Tooltip, notification } from "antd";
import "./management_user.css";
import { MenuList, MenuUser } from "../../components/hoc_management_user";
import { useUserManagementLogic } from "../../components/hoc_management_user";

const ManagementUser: React.FC = () => {
     const transformStyle = { transform: "scale(0.80)", transformOrigin: "top left", width: "125%" };

     const {
          form,
          autosaveStatus,
          handleNameChange,
          handleFormValuesChange,
          selectedMenuListKeys,
          setSelectedMenuListKeys,
          menuUserItems,
          handleCopyMenu,
          isCopying,
          handleRefreshMenuList,
          disabledMenuListKeys,
          warehouseOptions,
          selectedMenuUserKeys,
          setSelectedMenuUserKeys,
          handleDeleteMenuUser
     } = useUserManagementLogic();

     return (
          <div id="iypr" style={transformStyle}>
               <div className="gjs-grid-row" id="icxpe">
                    <div className="gjs-grid-column" id="ii1ie">
                         <Breadcrumb
                              items={[
                                   {
                                        href: "#/dashboard/list_user",
                                        title: (
                                             <>
                                                  <span>List User</span>
                                             </>
                                        ),
                                   },
                                   { title: "Management User" },
                              ]}
                         />
                    </div>
               </div>
               <div className="gjs-grid-row" id="xcxvvv">
                    <Space style={{ marginLeft: "10px" }}>
                         {autosaveStatus === "processing" && (
                              <Tooltip title="Autosave sedang berjalan...">
                                   <LoadingOutlined style={{ color: "#1890ff" }} />
                              </Tooltip>
                         )}
                         {autosaveStatus === "error" && (
                              <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                   <WarningOutlined style={{ color: "#ff4d4f" }} />
                              </Tooltip>
                         )}
                         {autosaveStatus === "stopped" && (
                              <Tooltip title="Autosave Stop.">
                                   <StopOutlined style={{ color: "#bfbfbf" }} />
                              </Tooltip>
                         )}
                         {autosaveStatus === "idle" && (
                              <Tooltip title="Autosave berhasil.">
                                   <CheckCircleOutlined style={{ color: "#52c41a" }} />
                              </Tooltip>
                         )}
                    </Space>
               </div>
               <div className="gjs-grid-row" id="ik37u">
                    <div className="gjs-grid-column" id="ikiyi">
                         <Form
                              layout="horizontal"
                              style={{ maxWidth: 500 }}
                              labelCol={{ style: { width: "150px", textAlign: "left" } }}
                              wrapperCol={{ style: { width: "290px" } }}
                              className="custom-info-purchase-request"
                              form={form}
                              onValuesChange={handleFormValuesChange}>
                              <Form.Item label="User ID" name="kode_grup1" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="Name" name="nama" style={{ marginBottom: "5px" }} required>
                                   <Input placeholder="" onChange={handleNameChange} />
                              </Form.Item>
                              <Form.Item label="Username " name="users" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item label="password " name="password" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item label="Jabatan" name="jabatan" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" />
                              </Form.Item>
                              <Form.Item label="Expired Date" name="expired_date" style={{ marginBottom: "5px" }}>
                                   <DatePicker
                                        format="DD/MM/YYYY"
                                        placeholder="Select date"
                                        style={{ width: "50%", fontSize: "14px" }}
                                        popupStyle={{ fontSize: "12px" }}
                                   />
                              </Form.Item>
                         </Form>
                    </div>
                    <div className="gjs-grid-column" id="iwykc">
                         <Form
                              layout="horizontal"
                              style={{ maxWidth: 500 }}
                              labelCol={{ style: { width: "150px", textAlign: "left" } }}
                              wrapperCol={{ style: { width: "290px" } }}
                              className="custom-info-purchase-request"
                              form={form}
                              onValuesChange={handleFormValuesChange}>
                              <Form.Item label="Status" name="status" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="Code Warehouse" name="warehouse_code" style={{ marginBottom: "5px" }}>
                                   <Select
                                        showSearch
                                        optionFilterProp="label"
                                        options={warehouseOptions}
                                        style={{ width: "100%" }}
                                        getPopupContainer={(triggerNode) => triggerNode.parentNode as HTMLElement}
                                   />
                              </Form.Item>
                              <Form.Item label="Tanggal Login" name="tgl_login" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="Tanggal Log Out" name="tgl_logout" style={{ marginBottom: "5px" }}>
                                   <Input placeholder="" readOnly />
                              </Form.Item>
                              <Form.Item label="Otoritas" name="otoritas" style={{ marginBottom: "5px" }}>
                                   <Checkbox.Group style={{ width: "100%" }}>
                                        <Row>
                                             <Col span={8}>
                                                  <Checkbox value="users">Users</Checkbox>
                                             </Col>
                                             <Col span={8}>
                                                  <Checkbox value="admin">Admin</Checkbox>
                                             </Col>
                                             <Col span={8}>
                                                  <Checkbox value="approval">Approval</Checkbox>
                                             </Col>
                                              <Col span={8}>
                                                  <Checkbox value="EDP">EDP</Checkbox>
                                             </Col>
                                        </Row>
                                   </Checkbox.Group>
                              </Form.Item>
                         </Form>
                    </div>
               </div>
               <Space></Space>
               <div className="gjs-grid-row" id="izd5i">
                    <div className="gjs-grid-column" id="iocjq">
                         <Form
                              layout="horizontal"
                              style={{ maxWidth: 500 }}
                              labelCol={{ style: { width: "150px", textAlign: "left" } }}
                              wrapperCol={{ style: { width: "290px" } }}
                              className="custom-info-purchase-request"
                         >
                              <div className="table-title" style={{ fontSize: "16px", marginBottom: "8px" }}>
                                   MENU LIST
                                   <Button
                                        id="copy_menu"
                                        className="pr-button"
                                        onClick={handleCopyMenu}
                                        loading={isCopying}
                                   >
                                        <CopyFilled />
                                        COPY MENU LIST
                                   </Button>
                              </div>
                              <MenuList
                                   selectedKeys={selectedMenuListKeys}
                                   setSelectedKeys={setSelectedMenuListKeys}
                                   disabledKeys={disabledMenuListKeys}
                              />
                         </Form>
                    </div>
                    <div className="gjs-grid-column" id="ib79u">
                         <Form
                              layout="horizontal"
                              style={{ maxWidth: 500 }}
                              labelCol={{ style: { width: "150px", textAlign: "left" } }}
                              wrapperCol={{ style: { width: "290px" } }}
                              className="custom-info-purchase-request">
                              <div className="table-title" style={{ fontSize: "16px", marginBottom: "8px" }}>
                                   MENU USER
                                   <Button id="delete_menu" className="pr-button" onClick={handleDeleteMenuUser}>
                                        <CloseCircleFilled />
                                        DELETE MENU USER
                                   </Button>
                              </div>
                              <MenuUser menuUserItems={menuUserItems} selectedKeys={selectedMenuUserKeys} setSelectedKeys={setSelectedMenuUserKeys} />
                         </Form>
                    </div>
               </div>
          </div>
     );
};

export default ManagementUser;
